import { Routes } from '@angular/router';

export const paymentsRoutes: Routes = [
    {
        path: 'upgrade',
        loadComponent: () => import('@sona/angular-payments/upgrade-page').then((m) => m.SonaUpgradePage)
    },
    {
        path: 'purchase',
        children: [
            /*
            Disabled until purchasing the credits addon is implemented
            {
                path: 'addon-credits',
                loadComponent: () => import('./pages/purchase-credits-addon-page.ng').then((m) => m.SonaPurchaseCreditsAddonPage)
            },
             */
            {
                path: 'feedback',
                loadComponent: () => import('@sona/angular-payments/purchase-feedback-page').then((m) => m.SonaPurchaseFeedbackPage)
            }
        ]
    }
];
